<template>
  <b-card no-body class="w-100">
    <div slot="header">
      <span v-if="fleetAvailable">
        Selected fleet:
        <strong>{{ fleet.fleetName }} ({{ fleet.vesselsInFleet || 0 }} vessels)</strong>
      </span>
      <span v-else>
        Fleets vessels
      </span>
    </div>

    <b-card-body class="position-relative p-0">
      <fleet-vessel-table
        v-if="fleetId"
        :absolute-mode="true"
        :fleet-id="fleetId"
        :fleets="fleets"
        :per-page="8"
        :edit="false"
        @fleet-loaded="handleFleetLoaded" />
      <div v-else class="text-center p-3">Please select a fleet</div>
    </b-card-body>
  </b-card>
</template>

<script>
import FleetVesselTable from './FleetVesselTable'

export default {
  name: 'fleet-vessels-card',
  components: {
    FleetVesselTable,
  },

  props: {
    fleetId: {
      type: String,
      default: undefined,
    },

    fleets: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fleet: {},
    };
  },

  methods: {
    handleFleetLoaded(fleet) {
      this.$emit('fleet-loaded', fleet);
      this.fleet = fleet;
    },
  },

  computed: {
    fleetAvailable() {
      return this.fleetId && this.fleet.fleetId;
    }
  },
}
</script>

<style scoped>

</style>
